import React from 'react';
import PropTypes from 'prop-types';
import { fixed } from '../../utils/formater';

function Price ({ value }) {
  const price = fixed(value);

  return (
    <div>{price + '\u00A0₽'}</div>
  );
}

Price.propTypes = {
  value: PropTypes.number.isRequired
};

export default Price;



// WEBPACK FOOTER //
// ./src/ui/Price/Price.js